import { defineStore } from "pinia";
import { StatusPriority } from "@/App/types/twiageTypes";
import type { HospitalStatuses, HospitalStatus } from "@/App/types/twiageTypes";
import PubnubServiceImpl from "@/App/services/PubnubService";
import { StatusesService } from "./../../Pages/Statuses/services";

export type StatusStore = {
  statuses: HospitalStatuses[];
};

const HospitalStatusUpdatesType = "HOSPITAL_STATUS_UPDATED";

const activeStatusesNotEmpty = (hospitalStatuses: HospitalStatuses): boolean =>
  hospitalStatuses.activeStatuses?.length > 0;
const updateStatusesLocally = ({
  store,
  hospitalStatuses,
  clearBeforeAdd = false,
}: {
  store: StatusStore;
  hospitalStatuses: HospitalStatuses[];
  clearBeforeAdd?: boolean;
}): void => {
  if (clearBeforeAdd) {
    store.statuses = [];
  } else {
    const hospitalIds = hospitalStatuses.map((hospitalStatuses) => hospitalStatuses.id);
    store.statuses = store.statuses.filter((status) => !hospitalIds.includes(status.id));
  }
  store.statuses.push(...hospitalStatuses.filter(activeStatusesNotEmpty));
};

export const useStatusesStore = defineStore({
  id: "statuses",
  state: (): StatusStore => ({
    statuses: [],
  }),
  actions: {
    async fetchStatuses() {
      try {
        const hospitalsData = await StatusesService.getHospitalsStatuses();
        updateStatusesLocally({
          store: this,
          hospitalStatuses: hospitalsData,
          clearBeforeAdd: true,
        });
        const channels = hospitalsData.map((status) => status.statusChannelId);
        PubnubServiceImpl.getInstance().subscribe<string>({
          channels,
          types: [HospitalStatusUpdatesType],
          callback: () => {
            this.updateStatuses();
          },
        });
      } catch (error) {
        // TODO
        console.log(error);
      }
    },

    async updateStatuses() {
      const hospitalData = await StatusesService.getHospitalsStatuses();
      updateStatusesLocally({ store: this, hospitalStatuses: hospitalData });
    },

    onSessionEnd() {
      this.statuses = [];
    },

    iftStatusesByHospitalId(hospitalId: string): HospitalStatus[] {
      const status = {
        _id: "dummyStatus",
        priority: StatusPriority.Info,
        status: "Beds Available",
        createdAt: "",
        createdBy: "",
      };
      return this.statuses.find((hospital: HospitalStatuses) => hospital.id === hospitalId)?.activeStatuses ?? [status];
    },
  },
});
